export const listInvoiceItems = `
   query listInvoiceItems($filter: InvoiceItemsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listInvoiceItems(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                customer
                amount
                currency
                description
                period {
                    start
                    end
                }
                price
                invoice
                quantity
                subscription
                unit_amount
           }
           nextToken
       }
   }
`;

export const getInvoiceItem = `
   query getInvoiceItem($customer: ID!, $id:ID!) {
       getInvoiceItem(customer:$customer, id:$id) {
            id
            customer
            amount
            currency
            description
            period {
                start
                end
            }
            price
            invoice
            quantity
            subscription
            unit_amount
       } 
}`;
